/** Spreadsheet-only fallback. PDFs detect vendor from content; stored rows can still have this. */
export const SONY_SPREADSHEET_FALLBACK_WARNING =
  'Could not auto-detect vendor, defaulting to Sony format';

/**
 * Drop the Sony-format fallback warning when ingest already resolved a different vendor
 * (e.g. a UUID-named Nikon MVP PDF that was parsed from page text).
 */
export function displayableIngestWarnings(
  vendor: string | undefined,
  warnings: string[] | undefined
): string[] {
  if (!warnings?.length) return [];
  const brand = (vendor || '').trim().toLowerCase();
  if (brand && brand !== 'sony' && brand !== 'unknown') {
    return warnings.filter((w) => w !== SONY_SPREADSHEET_FALLBACK_WARNING);
  }
  return warnings;
}
